// Hand-crafted enei.in content — written in the brand voice.
// All imagery sourced from Unsplash / Pexels per design guidelines.

export const HERO = {
    image: "https://images.pexels.com/photos/2815093/pexels-photo-2815093.jpeg?auto=compress&cs=tinysrgb&w=1920&q=70",
    eyebrow: "Northeast India · 8 states · 220+ tribes",
    title_lines: ["The Northeast", "is not a checklist.", "It is a conversation."],
    sub: "Begin it with us — the rivers, the rain, the rice beer at dusk.",
};

export const STATES = [
    {
        slug: "assam",
        name: "Assam",
        tagline: "Rivers, rhinos, tea.",
        body: "The Brahmaputra is wider than you think — and louder. Wake before five, take a country boat to Majuli, and watch the river take its time. By afternoon, you'll be drinking second-flush tea in Jorhat that ruined every other cup.",
        season: "Nov–Mar · Kaziranga safaris · Bihu in April",
        image: "https://images.unsplash.com/photo-1602020277972-99978250c8bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxhc3NhbSUyMHRlYSUyMGdhcmRlbnxlbnwwfHx8fDE3NzgzOTU5MjR8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-7 lg:row-span-2",
        height: "h-[460px] lg:h-[640px]",
    },
    {
        slug: "meghalaya",
        name: "Meghalaya",
        tagline: "Where the clouds live.",
        body: "Walk into Mawlynnong on a Sunday and the village is silent — they're all in church. The living-root bridges in Nongriat are not photographs. They are 200-year arguments between Khasi grandfathers and the river.",
        season: "Sept–Nov · Wettest July, but also wildest",
        image: "https://images.unsplash.com/photo-1669628182335-4c50980f419d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtZWdoYWxheWElMjBsaXZpbmclMjByb290JTIwYnJpZGdlfGVufDB8fHx8MTc3ODM5NTkyNHww&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-5 lg:row-span-1",
        height: "h-[360px] lg:h-[310px]",
    },
    {
        slug: "nagaland",
        name: "Nagaland",
        tagline: "Sixteen tribes. One blue sky.",
        body: "December in Kisama smells of woodsmoke and pork with bamboo shoot. Stay with an Angami family in Khonoma — Asia's first green village — and you'll learn that hospitality here is a discipline, not a gesture.",
        season: "Dec 1–10 · Hornbill Festival · Kohima",
        image: "https://images.unsplash.com/photo-1692652567309-5ac9ae7fe6f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxkenVrb3UlMjB2YWxsZXklMjBuYWdhbGFuZHxlbnwwfHx8fDE3NzgzOTU5MjR8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-5 lg:row-span-1",
        height: "h-[360px] lg:h-[310px]",
    },
    {
        slug: "arunachal",
        name: "Arunachal Pradesh",
        tagline: "Where dawn is a discipline.",
        body: "From Bomdila the road climbs through Sela's frozen lake and drops into Tawang — the second-largest monastery on earth. The 5 a.m. prayers are not for show. They are the reason the mountains stay still.",
        season: "Apr–Oct · Inner Line Permit required",
        image: "https://images.pexels.com/photos/2815093/pexels-photo-2815093.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "lg:col-span-7 lg:row-span-2",
        height: "h-[460px] lg:h-[640px]",
    },
    {
        slug: "manipur",
        name: "Manipur",
        tagline: "A lake that breathes.",
        body: "Loktak is the only floating lake in the world — its phumdis drift like a slow herd. At Kangla, the Manipuri Raas Leela is danced barefoot. Resilience here is not a hashtag. It is a posture.",
        season: "Oct–Mar · Sangai Festival in November",
        image: "https://images.unsplash.com/photo-1674722612663-c34ad2c24648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxsb2t0YWslMjBsYWtlJTIwbWFuaXB1cnxlbnwwfHx8fDE3NzgzOTU5NDZ8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-4 lg:row-span-1",
        height: "h-[360px] lg:h-[340px]",
    },
    {
        slug: "mizoram",
        name: "Mizoram",
        tagline: "Quiet hills, loud kindness.",
        body: "Aizawl is built on a single ridge — its houses cling to the slope like a held breath. Sundays the whole state goes still for church, then opens for tea and chow. Bamboo is currency, scaffolding, and lunch.",
        season: "Oct–Mar · Chapchar Kut in March",
        image: "https://images.unsplash.com/photo-1742489468038-b7e948b6fab1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxtaXpvcmFtJTIwaGlsbHN8ZW58MHx8fHwxNzc4Mzk1OTY0fDA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-4 lg:row-span-1",
        height: "h-[360px] lg:h-[340px]",
    },
    {
        slug: "tripura",
        name: "Tripura",
        tagline: "Bengal's quiet sibling.",
        body: "Ujjayanta Palace at dusk turns the colour of marigolds. Out at Unakoti, 9th-century rock carvings stare back at you, half-swallowed by jungle. Bring questions; locals will offer answers and second helpings.",
        season: "Oct–Mar · Garia Puja in April",
        image: "https://images.unsplash.com/photo-1762707675084-01ac3bd4e9f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtZWdoYWxheWElMjBsaXZpbmclMjByb290JTIwYnJpZGdlfGVufDB8fHx8MTc3ODM5NTkyNHww&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-4 lg:row-span-1",
        height: "h-[360px] lg:h-[340px]",
    },
    {
        slug: "sikkim",
        name: "Sikkim",
        tagline: "Prayer flags. Cold air. Clarity.",
        body: "On a clear morning at Tiger Hill, Kanchenjunga turns gold for ninety seconds, then is gone. Sikkim is India's first fully organic state — the radish in your thukpa was pulled from the ground at sunrise.",
        season: "Mar–May & Oct–Nov · Losar in Feb",
        image: "https://images.unsplash.com/photo-1672096099708-e9e379cd63c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxzaWtraW0lMjBwcmF5ZXIlMjBmbGFnc3xlbnwwfHx8fDE3NzgzOTU5NDZ8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-12 lg:row-span-1",
        height: "h-[360px] lg:h-[420px]",
    },
];

export const TRAVELLERS = [
    {
        id: "adventure",
        number: "01",
        title: "The Adventure Seeker",
        line: "Trails with no crowds. Rivers with no names.",
        body: "Trek the Goecha La. Kayak the Siang in flood season. Sleep above 13,000 ft and watch the Milky Way feel close enough to touch.",
    },
    {
        id: "culture",
        number: "02",
        title: "The Culture Lover",
        line: "Sit inside a Naga longhouse. Stay till the fire dies.",
        body: "Listen to a Manipuri Pung Cholom drummer. Learn what the colours of a thangka are really saying. Eat with your hands and ask why.",
    },
    {
        id: "luxury",
        number: "03",
        title: "The Luxury Traveller",
        line: "Every detail handled. Every silence kept.",
        body: "Heritage tea bungalows in Dibrugarh. Glamping above the clouds in Tawang. Private cardamom estates in West Sikkim. Curated, not crowded.",
    },
    {
        id: "backpacker",
        number: "04",
        title: "The Backpacker",
        line: "Stretch ₹1000 across three days. Come home rich.",
        body: "Shared sumos. Homestays at ₹600 a night. Rice beer poured by a grandmother who already considers you family. The best stories cost the least.",
    },
];

export const FESTIVALS = [
    { name: "Hornbill Festival", where: "Kisama, Nagaland", when: "Dec 1–10", note: "Sixteen tribes, one fire." },
    { name: "Ziro Music Festival", where: "Ziro Valley, Arunachal", when: "Late September", note: "Indie music among rice paddies." },
    { name: "Bihu", where: "Across Assam", when: "Mid April", note: "The Brahmaputra dances in three steps." },
    { name: "Cherry Blossom Festival", where: "Shillong, Meghalaya", when: "Mid November", note: "Pink streets, brass bands." },
    { name: "Sangai Festival", where: "Imphal, Manipur", when: "Late November", note: "Named for the dancing deer." },
    { name: "Losar", where: "Tawang & Sikkim", when: "Feb / Mar", note: "Tibetan New Year. Butter tea, butter lamps." },
];

export const PLACE_RIBBON = [
    "Tawang", "Ziro", "Majuli", "Mawlynnong", "Dzukou", "Khonoma",
    "Loktak", "Kaziranga", "Pelling", "Cherrapunji", "Aizawl",
    "Unakoti", "Tuophema", "Yumthang", "Bomdila", "Nongriat",
];
